import React from "react";
import { Reveal } from "../components/Reveal";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang, useLocalePath } from "../contexts/LanguageContext";
import SEO, { organizationSchema } from "../components/SEO";

export default function Services() {
  const { t } = useLang();
  const localePath = useLocalePath();
  const imgs = [
    "/images/gallery/lsp-4.jpg", "/images/gallery/lsp-5.jpg",
    "/images/gallery/lsp-6.jpg", "/images/gallery/lsp-7.jpg",
    "/images/gallery/lsp-8.jpg", "/images/gallery/lsp-9.jpg",
  ];
  const blocks = t("services_page.blocks") || [];

  return (
    <div>
      <SEO metaKey="services" pathname="/services" schemas={[organizationSchema()]} />

      <section className="relative isolate bg-forest text-white">
        <div className="absolute inset-0 z-0">
          <img src="/images/gallery/lsp-4.jpg" alt="" className="w-full h-full object-cover" loading="eager" />
          <div className="absolute inset-0 bg-black/55 md:bg-forest/75" />
        </div>
        <div className="relative z-10 max-w-[1400px] mx-auto px-5 sm:px-8 lg:px-12 py-28 lg:py-40 min-h-[70vh] flex flex-col justify-end">
          <Reveal>
            <div className="editorial-divider mb-6 max-w-xs" style={{ color: "#E3A839" }}>{t("services_page.eyebrow")}</div>
            <h1 className="font-serif font-light text-5xl sm:text-6xl lg:text-8xl leading-[0.96] max-w-5xl">
              {t("services_page.h1a")} <br /> <span className="italic text-mustard">{t("services_page.h1b")}</span>
            </h1>
            <p className="mt-8 max-w-2xl text-lg text-white/85 leading-relaxed">{t("services_page.intro")}</p>
          </Reveal>
        </div>
      </section>

      <section className="bg-ivory">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 lg:px-12 py-16 lg:py-24 space-y-24 lg:space-y-32">
          {blocks.map((b, i) => (
            <Reveal key={i}>
              <div className={`grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center ${i % 2 ? "lg:[&>div:first-child]:order-2" : ""}`}>
                <div className="lg:col-span-6">
                  <img src={imgs[i]} alt={b.title} className="w-full h-[420px] lg:h-[520px] object-cover rounded-xl" loading="lazy" />
                </div>
                <div className="lg:col-span-6">
                  <div className="font-serif text-mustard text-5xl mb-4">{String(i + 1).padStart(2, "0")}</div>
                  <h2 className="font-serif text-4xl lg:text-5xl text-forest leading-[1.05]">{b.title}</h2>
                  {b.intro && <p className="mt-5 text-ink/75 text-lg leading-relaxed">{b.intro}</p>}
                  <ul className="mt-8 space-y-3">
                    {(b.points || []).map((p) => (
                      <li key={p} className="flex items-center gap-3 border-b border-dust pb-3">
                        <span className="w-2 h-2 rounded-full bg-terracotta" />
                        <span className="text-ink/80">{p}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-forest text-ivory">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 lg:px-12 py-20 lg:py-28 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
          <h3 className="font-serif text-3xl lg:text-5xl max-w-2xl">{t("services_page.cta")}</h3>
          <Link to={localePath("/contact")} data-testid="services-cta-contact" className="btn-pill bg-mustard text-forest hover:bg-mustard/90 whitespace-nowrap">
            {t("services_page.cta_btn")} <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
